<template>
  <a-drawer
    :title="title"
    :visible="addGroupModal"
    :width="900"
    :maskClosable="true"
    :destroyOnClose="true"
    placement="right"
    style="overflow: auto; padding-bottom: 53px"
    @close="handleCancelAdd"
  >
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
      <a-form-item label="分组名称:">
        <a-input
          v-decorator="[
            'groupName',
            {
              rules: [{ required: true, message: '请输入分组名称' }]
            }
          ]"
        />
      </a-form-item>
      <a-form-item label="排序:">
        <a-input-number v-decorator="['sort']" />
      </a-form-item>

      <a-form-item label="描述:">
        <a-textarea
          v-decorator="['description']"
          placeholder="请输入描述"
          :auto-size="{ minRows: 3, maxRows: 3 }"
        />
      </a-form-item>
    </a-form>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancelAdd"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleAddOk" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>
<script>
import { addGroup, editGroup } from '@/api/product';
export default {
  data() {
    return {
      id: '',
      title: '新增',
      descipt: '',
      addGroupModal: false, //添加弹框
      addLoading: false, //添加产品loading
      formLayout: 'horizontal',
      form: this.$form.createForm(this, { name: 'coordinated' })
    };
  },
  methods: {
    handleAddVisible(record) {
      console.log(record);
      if (record) {
        this.id = record.id;
        this.title = '编辑';
        this.$nextTick(() => {
          this.form.setFieldsValue({
            groupName: record.groupName,
            sort: record.sort,
            description: record.description
          });
        });
      }
      this.addGroupModal = true;
    },
    //取消
    handleCancelAdd() {
      this.addGroupModal = false;
      this.form.resetFields();
    },
    //q确定
    handleAddOk(e) {
      e.preventDefault();

      this.form.validateFields((err, values) => {
        if (!err) {
          let params = Object.assign(values);
          let httpUrl = '';
          if (this.title == '编辑') {
            httpUrl = editGroup;
            params.id = this.id;
          } else {
            httpUrl = addGroup;
          }
          httpUrl(params).then(res => {
            if (res.success) {
              // console.log(res);
              this.$message.success('操作成功');
              //亲空表单
              this.form.resetFields();
              this.$emit('initProductList', '1');
              this.addGroupModal = false;
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },
    handleSelectChange(value) {
      console.log(value);
      this.form.setFieldsValue({
        note: `Hi, ${value === 'male' ? 'man' : 'lady'}!`
      });
    }
  }
};
</script>
<style lang="less" scoped>
.fieldBtn {
  padding: 0 40px;
}
.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
